<template>
  <!--언어 선택-->
  <div class="container-contents">
    <button
      class="button-dim button-full-width button-small"
      ref="triggerUserRef"
      @click="toggleDropdown"
      :class="{
        active: showDropdown,
      }"
    >
      <p class="truncate">
        {{ nickname || '닉네임 선택' }}
      </p>
      <component
        class="icon-medium"
        :is="showDropdown ? ChevronUpIcon : ChevronDownIcon"
      />
    </button>
    <Dropdown
      v-if="showDropdown"
      position="below"
      :trigger-ref="triggerUserRef"
      :class="{ active: showDropdown }"
      @close="toggleDropdown"
    >
      <ul class="wrapper-list">
        <li
          v-for="user in userPresetList"
          :key="user.userId"
          @click="selectNickname(user, false)"
        >
          <p class="truncate">{{ user.nickname }}</p>
          <button
            type="button"
            class="button-small button-primary"
            @click.stop="selectNickname(user, true)"
          >
            전체 바꾸기
          </button>
        </li>
      </ul>
    </Dropdown>
  </div>
</template>

<script setup lang="ts">
import { defineProps, ref } from 'vue';

import ChevronDownIcon from '@/components/icons/IconChevronDown.vue';
import ChevronUpIcon from '@/components/icons/IconChevronUp.vue';
import Dropdown from '@/components/shared/base/Dropdown.vue';
import { IResponseMcsSubUser } from '@/types/response';

const nickname = defineModel<string>({
  required: true,
  default: '',
});

withDefaults(
  defineProps<{
    userPresetList: IResponseMcsSubUser[];
  }>(),
  {
    userPresetList: () => [],
  }
);
const emit = defineEmits<{
  change: [person?: IResponseMcsSubUser, isAll?: boolean];
}>();

const triggerUserRef = ref();
const showDropdown = ref<boolean>(false);

const toggleDropdown = () => {
  showDropdown.value = !showDropdown.value;
};

const selectNickname = (person: IResponseMcsSubUser, isAll: boolean) => {
  nickname.value = person.nickname;
  emit('change', person, isAll);
  toggleDropdown();
};
</script>

<style scoped lang="scss">
.container-contents {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 3rem;
  gap: 0.25rem;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
  flex: 1;
}

p {
  line-height: 120%;
  width: 100%;
  text-align: left;
}

::v-deep(.dropdown-content) {
  width: 24.5rem;
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wrapper-list {
  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 0.75rem;
    border-radius: 0.5rem;
    cursor: pointer;
    transition: background 0.2s;
    position: relative;

    &:hover {
      background: var(--surface-hover-gray-dimmer);

      button {
        opacity: 1;
        visibility: visible;
      }
    }

    p {
      margin: 0;
      font-size: 0.9375rem;
      color: var(--color-gray-800);
    }

    button {
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.2s ease;
    }
  }
}
</style>
